module.exports = __webpack_public_path__ + "media/images/lb/851-2305cb7875afcba3a75bc819cf8527a0.svg";